import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import MobileTabBar from '../components/MobileTabBar';
import DashboardHome from '../components/DashboardHome';
import PoliciesView from '../components/PoliciesView';
import PolicyComparison from '../components/PolicyComparison';
import DocumentsView from '../components/DocumentsView';
import IDCardsView from '../components/IDCardsView';
import PaymentView from '../components/PaymentView';
import ClaimsView from '../components/ClaimsView';
import ReferralView from '../components/ReferralView';
import SettingsView from '../components/SettingsView';

const Dashboard = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <div className="text-gray-600">Loading your dashboard...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex min-h-screen bg-gray-50 pt-20">
      <Sidebar isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      {/* pb-24 keeps content clear of the mobile tab bar */}
      <main className="flex-1 w-full min-w-0 lg:ml-280 p-4 sm:p-6 lg:p-8 pb-24 lg:pb-8">
        <Routes>
          <Route index element={<DashboardHome />} />
          <Route path="policies" element={<PoliciesView />} />
          <Route path="comparison" element={<PolicyComparison />} />
          <Route path="documents" element={<DocumentsView />} />
          <Route path="id-cards" element={<IDCardsView />} />
          <Route path="payment" element={<PaymentView />} />
          <Route path="claims" element={<ClaimsView />} />
          <Route path="referrals" element={<ReferralView />} />
          <Route path="settings" element={<SettingsView />} />
        </Routes>
      </main>
      <MobileTabBar onMoreClick={() => setIsMenuOpen(true)} />
    </div>
  );
};

export default Dashboard;